module.exports = __webpack_public_path__ + "img/category-casino-hover.3b6ba3d4.png";